import { createFileRoute } from "@tanstack/react-router";
import { UseCasePage } from "@/components/blocks/use-cases/UseCasePage";
import { buildUseCaseHead, loadPageLocale } from "@/lib/page-seo";

export const Route = createFileRoute(
	"/{-$locale}/cas-usage/controle-qualite-proprete",
)({
	component: () => <UseCasePage useCase="cleaning" />,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData ? buildUseCaseHead("cleaning", loaderData.locale) : {},
});
